import { z } from 'zod';
import { uuid, isoDateTime } from './common.js';
/** Milestone 7: parallel run and cut-over (docs/design/08). */
export const cutoverItemDto = z.object({
    key: z.string(),
    group: z.string(),
    title: z.string(),
    help: z.string(),
    /** auto: computed from the system; manual: ticked by a person. */
    kind: z.enum(['auto', 'manual']),
    done: z.boolean(),
    detail: z.string().nullable(),
    doneBy: z.string().nullable(),
    doneAt: isoDateTime.nullable(),
    note: z.string().nullable(),
    link: z.string().nullable(),
});
export const setCutoverItemRequest = z.object({ done: z.boolean(), note: z.string().trim().max(1000).nullable().optional() });
export const parallelQuery = z.object({
    from: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
    to: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
    onlyDiffs: z.coerce.boolean().default(true),
});
export const parallelOrderRow = z.object({
    orderId: uuid,
    orderNumber: z.string(),
    shopName: z.string().nullable(),
    ourStatus: z.string(),
    ourShipped: z.number().int(),
    ourOrdered: z.number().int(),
    ourTracking: z.string().nullable(),
    ourInvoiceMinor: z.number().int().nullable(),
    navState: z.string().nullable(),
    navShipped: z.number().int().nullable(),
    navTracking: z.string().nullable(),
    navInvoiceNo: z.string().nullable(),
    navInvoiceMinor: z.number().int().nullable(),
    issues: z.array(z.string()),
});
export const parallelStockRow = z.object({
    sku: z.string(),
    title: z.string(),
    warehouseCode: z.string(),
    ours: z.number().int(),
    navision: z.number().int(),
    difference: z.number().int(),
});
//# sourceMappingURL=cutover.js.map